import {StyleSheet, View} from 'react-native';
import React from 'react';
import fontWeightToFamily from '@/Assets/Fonts/fontWeightToFamily';
import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';
import Box from '@/Atoms/Box';
import CCText from '@/Atoms/CCText';
import ChessboardWithArrow from '@/Components/ChessboardWithArrow';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';

interface ChessBoardCardProps {
  id: number;
  fen: string;
  puzzleName: string;
  orientation: string;
  score: string;
  solveTime: string | null;
  attemptCount: string;
  solved: string;
  puzzleTime: string;
}

const ChessBoardCard: React.FC<ChessBoardCardProps> = ({
  id,
  fen,
  puzzleName,
  orientation,
  score,
  solveTime,
  attemptCount,
  solved,
  puzzleTime,
}) => {
  const defaultFen = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';

  const renderStatus = () => {
    if (attemptCount == '0') {
      return (
        <>
          <Icon name="minus-circle" size={12} color={CCColors.Error} />
          <CCText style={styles.statusMessage} color={CCColors.Error}>
            Not Attempted
          </CCText>
        </>
      );
    }

    if (solved == '0') {
      return (
        <>
          <Icon name="close-circle" size={12} color={CCColors.Red} />
          <CCText style={styles.statusMessage} color={CCColors.Red}>
            Not Solved
          </CCText>
        </>
      );
    }

    if (score == '0') {
      return (
        <>
          <Icon name="alert-circle" size={12} color={CCColors.Blue} />
          <CCText style={styles.statusMessage} color={CCColors.Blue}>
            Solved with Hint
          </CCText>
        </>
      );
    }

    return (
      <>
        <Icon name="check-circle" size={12} color={CCColors.Green} />
        <CCText style={styles.statusMessage} color={CCColors.Green}>
          Solved
        </CCText>
      </>
    );
  };

  const getAttemptsColor =
    parseInt(attemptCount, 10) < 4 && parseInt(attemptCount, 10) !== 0
      ? CCColors.Green
      : CCColors.Red;

  return (
    <Box key={id} style={styles.container}>
      <View style={styles.boardContainer}>
        <ChessboardWithArrow
          position={fen || defaultFen}
          handleNewFen={() => {}}
          lastMoveFen={fen || defaultFen}
          boardOrientation={orientation}
          disabled={true}
        />
      </View>

      <Box style={styles.infoContainer}>
        <View style={styles.puzzleHeader}>
          <CCText style={styles.title} numberOfLines={1} ellipsizeMode={'tail'}>
            {puzzleName}
          </CCText>
        </View>

        <Box style={styles.infoBox}>
          <View style={styles.statusContainer}>{renderStatus()}</View>

          <View style={styles.bottomInfoRow}>
            <CCText fontSize={FontSizes[12]}>
              Attempts:{' '}
              <CCText fontWeight="bold" color={getAttemptsColor}>
                {attemptCount}
              </CCText>
            </CCText>

            <View style={styles.clockContainer}>
              <Icon name="clock-outline" size={14} color={CCColors.Green} />
              <CCText style={styles.clockText} fontSize={FontSizes[12]}>
                {solveTime ? (
                  solveTime
                ) : (
                  <CCText fontWeight="bold" color={CCColors.Red}>
                    NA
                  </CCText>
                )}
                /{puzzleTime}s
              </CCText>
            </View>
          </View>
        </Box>
      </Box>
    </Box>
  );
};

export default ChessBoardCard;

const styles = StyleSheet.create({
  container: {
    width: 250,
    backgroundColor: CCColors.White,
    borderRadius: 8,
    padding: 4,
    margin: 5,
    border: `1px solid ${CCColors.Border}`,
    alignItems: 'center',
  },
  boardContainer: {
    width: '100%',
    maxWidth: 240,
    // paddingTop: 10,
    padding: 5,
    backgroundColor: CCColors.BrightYellow,
    justifyContent: 'center',
    aspectRatio: 1,
    flexShrink: 0,
  },
  infoContainer: {
    padding: 2,
    width: '100%',
    alignItems: 'center',
  },
  puzzleHeader: {
    alignItems: 'center',
  },
  title: {
    fontSize: FontSizes[16],
    fontWeight: '600',
    color: CCColors.TextColor.Dark,
    textTransform: 'capitalize',
    lineHeight: 30,
    maxWidth: 230,
    overflow: 'hidden',
    justifyContent: 'center',
  },
  infoBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderWidth: 1,
    borderColor: CCColors.BorderBottom,
    borderRadius: 4,
    paddingHorizontal: 5,
    width: '100%',
  },
  statusContainer: {
    paddingHorizontal: 3,
    flexDirection: 'row',
    alignItems: 'center',
  },
  statusMessage: {
    fontSize: FontSizes[14],
    padding: 3,
  },
  bottomInfoRow: {
    paddingHorizontal: 3,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: 2,
  },
  clockContainer: {
    flexDirection: 'row',
  },
  clockText: {
    paddingLeft: 4,
  },
});
